import React from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import Logo from "../assets/Mental-Health-Action-Day-Hor-black.svg";

const Header = ({ lang }) => {
  return (
    <Navbar>
      <Container>
        {/* 
          Mental Health <em>Action</em> Day
        </Navbar.Brand> */}
        <div className="mr-auto">
          <Navbar.Brand href="/">
            <Logo />
          </Navbar.Brand>
        </div>
        <Nav className="links-nav ml-auto">
          <Nav.Link
            className="btn d-none d-md-block btn-outline-dark header-nav-links"
            href="https://www.mentalhealthactionday.art/"
          >
            Partner&nbsp;Toolkit
          </Nav.Link>
          <Nav.Link
            className="btn btn-dark text-white header-nav-links"
            href="/"
          >
            EN
          </Nav.Link>
          <Nav.Link
            className="btn btn-outline-dark header-nav-links"
            href="/es"
          >
            ES
          </Nav.Link>
        </Nav>
      </Container>
    </Navbar>
  );
};
export default Header;
